/**Тип пикера */
export enum DatepickerTypeEnum {
  /**Выбор времени */
  Time = "time",
  /**Выбор даты */
  Date = "date",
  /**Выбор даты со временем */
  DateTime = "date-time",
  /**Выбор недели */
  Week = "week",
  /**Выбор месяца */
  Month = "month",
  /**Выбор года */
  Year = "year",
}
